/*eslint-disable */

import 'vue-datetime/dist/vue-datetime.css'

import { Datetime } from 'vue-datetime';
import { bus } from '@/main';
import toast from '@/services/toast';

const $ = window.jQuery = require('jquery'); 
// You need a specific loader for CSS files
export default {
  name: 'individual-activity-tracker',
  components: {
    datetime: Datetime,
  },
  props: [],
  data () {
    return {
      getActivityTrackerListData:null,
      getActivityTrackerListDataResults:[],
      start_date_for_f:'',
      end_date__for_f:'',
      start_date:'',
      end_date:'',
      date:new Date(),
      maxDatetime:new Date().toISOString(),
      submitted:false,
      apiResLoader:false,
      userFilterInfoPopupState:false,
      userFilterInfoPopupStateClass:false
    }
  },
  computed: {

  },
  mounted () {
    $(window).scrollTop(0);
    this.userFilterInfoPopupState = true
    setTimeout(() => {
      this.userFilterInfoPopupStateClass = true
    }, 10);
    const previous = new Date(this.date.getTime());
    previous.setDate(this.date.getDate() - 1);
    this.start_date = previous;
    this.end_date = new Date()
    this.getActivityTrackerListMethod();
  },
  methods: {
    clickedOutside() {
      this.userFilterInfoPopupStateClass = false
      setTimeout(() => {
        this.userFilterInfoPopupState = false;
        bus.$emit('individualActivityTrackerStateBus', false);
        document.body.classList.remove('body_right_scroll_remove');
      }, 600);
    },
    coreTeamFilterMethod(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          if(this.start_date_for_f > this.end_date__for_f){
            toast.error('Oops your end date is in an incorrect format. Please input again.')
          }else{
            this.submitted = true
            this.apiResLoader = true
            let data = {
              start_date : this.start_date_for_f,
              end_date : this.end_date__for_f
            }        
            this.$store.dispatch('selfUserActivityTrackerMethod', data).then((res) => {
              this.getActivityTrackerListData = res.data.data
              this.getActivityTrackerListDataResults = this.getActivityTrackerListData.results
              this.start_date =  this.start_date_for_f
              this.end_date =  this.end_date__for_f
              this.submitted = false
              this.apiResLoader = false
            }).catch((err) => {
              this.submitted = false
              this.apiResLoader = false
            })
          }
        }
      })
    },
    getActivityTrackerListMethod(){
      let data = {
        start_date : this.start_date,
        end_date : this.end_date
      }        
      this.$store.dispatch('selfUserActivityTrackerMethod', data).then((res) => {
        this.getActivityTrackerListData = res.data.data
        this.getActivityTrackerListDataResults = this.getActivityTrackerListData.results
      })
    },
  }
}


